export default __webpack_public_path__ + "static/media/chair-steel.f0d72d2f.jpg";